import React, { useEffect } from 'react'

import Header from '../../../components/Turkey/Header/Header'
import UnderHeader from '../../../components/UnderHeader/UnderHeader'
import PageTitle from '../../../components/Turkey/PageTitle/PageTitle'
import Footer from '../../../components/Turkey/Footer/Footer'
import LogoPartner from '../../../components/LogoPartner/LogoPartner'
import ProductsItem from '../../../components/Turkey/ProductsItem/ProductsItem'

export default function Products() {
  useEffect(() => {
    window.scrollTo({ top:0 ,behavior: "smooth" })
  }, [])

  return (
    <>
      <Header page={'products'} />
      <UnderHeader className={'products'} />
      <PageTitle mainTitle={'ÜRÜNLERİMİZ'} page={'ÜRÜNLERİMİZ'} />
      <ProductsItem />
      <LogoPartner />
      <Footer />
    </>
  )
}
